import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { json } from '@angular-devkit/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { LocaleService } from '../../services/locale/locale.service';

@Component({
  selector: 'td-wb-svg-animation',
  templateUrl: 'svg-animation.component.html',
  styleUrls: ['svg-animation.component.scss'],
  imports: [
    LottieComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgAnimationComponent implements OnInit {
  @Input() animation: string;
  @Input() dimensions: { width: number; height: number };
  @Input() loop: boolean = false;
  styles: Partial<CSSStyleDeclaration>;
  options: AnimationOptions;

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private localeService: LocaleService) {}

  ngOnInit(): void {
    import((`./animations-library/${this.animation}-${this.localeService.getLanguage()}.json`)).then((animationData: json.JsonObject): void => {
      this.options = {
        animationData: animationData.default,
        loop: this.loop
      };
      this.styles = {
        maxWidth: `${this.dimensions?.width}px`,
        maxHeight: `${this.dimensions?.height}px`,
        margin: '0 auto'
      };
      this.changeDetectorRef.markForCheck();
    });
  }
}
